module.exports = __webpack_public_path__ + "static/media/01suh.1f5473cc.png";